import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { AuthService } from '@app-services/auth.service';
import { Admin } from '@app-models/site';
import { LoadingScreenService } from '@app-services/loading-screen.service';

import { errorMessages } from '../../../../message/error';

@Component({
  selector: 'app-browse-logo',
  templateUrl: './browse-logo.component.html',
  styleUrls: ['./browse-logo.component.scss']
})
export class BrowseLogoComponent implements OnInit {
  _e = errorMessages.TH;
  header: string;
  hintMessage: string;
  errBiggerSizeMessage: string;
  oldUrlLogo: any;
  fg: FormGroup;
  private logoHospital: any;
  constructor(
    public dialogRef: MatDialogRef<BrowseLogoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private authSer: AuthService,
    private _ls: LoadingScreenService
  ) {
    if (data) {
      if (data.oldUrlLogo) { this.oldUrlLogo = data.oldUrlLogo; }
      console.log('test url : ' + this.oldUrlLogo);
    }
  }

  ngOnInit() {
    this.fg = this._fb.group({
      displayLogoName: ''
    });
  }

  onFileChange(event) {
    this.logoHospital = event.target.files;
    // this.fg.displayNameLogo = event.target.files[0].name;
    console.log(event);
    if (this.logoHospital[0].size > 205000) {
      console.log('File is too big!');
      this.fg.get('displayLogoName').setValue('');
      this.fg.get('displayLogoName').setErrors({ 'size': true });
      this.fg.get('displayLogoName').markAsTouched();
    } else {
      this.fg.get('displayLogoName').setValue(this.logoHospital[0].name);
      console.log('test url : ' + this.oldUrlLogo);
    }
  }

  onSubmit(): void {
    this.fg.markAsDirty();
    if (this.fg.get('displayLogoName').value !== '') {
      this._ls.startLoading();
      const start = this.oldUrlLogo.indexOf('logos%2F') + 8;
      const end = this.oldUrlLogo.indexOf('?alt');
      const imUUID = this.oldUrlLogo.substring(start, end);
      let newUrl = null;
      this.authSer.uploadLogoToFireStorage(this.logoHospital, false, imUUID)
        .then((url: string) => {
          newUrl = url;
        }).catch((uploadError) => {
        // Handle Errors here.
        console.log('error.code : ' + uploadError.code + ', error.msg : ' + uploadError.message);
      }).finally(() => {
        this._ls.stopLoading();
        this.dialogRef.close(newUrl); });
    } else {
      this.fg.get('displayLogoName').setErrors({ required: true });
      this.fg.get('displayLogoName').markAsTouched();
    }
  }
}
